import { render, staticRenderFns } from "./VideoExpansion.vue?vue&type=template&id=f278311c&scoped=true&"
import script from "./VideoExpansion.vue?vue&type=script&lang=js&"
export * from "./VideoExpansion.vue?vue&type=script&lang=js&"
import style0 from "./VideoExpansion.vue?vue&type=style&index=0&id=f278311c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f278311c",
  null
  
)

export default component.exports